// both throw on malformed input; callers fall back

const decodeUtf8 = (base64: string): string =>
  decodeURIComponent(atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

export function parseJwt(token: string): any {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  return JSON.parse(decodeUtf8(base64));
}

export function decodeBase64(token: string): any {
  var base64 = token.replace(/-/g, '+').replace(/_/g, '/');

  return JSON.parse(decodeUtf8(base64));
}
